const jsonToUrl = (obj) => Object.keys(obj).reduce( (acc, k) => (obj[k] && obj[k] != '' ? `${acc}&${k}=${obj[k]}` : acc) ,'');

export default jsonToUrl;


